<script lang="ts">
  import type { CalcResult, SearchResultItemProps } from "../SearchControllers";

  let { density, resultItem, selected, callAction }: SearchResultItemProps =
    $props();

  let item = $derived(resultItem.item) as CalcResult;
</script>

<li class:search-selected={selected} class="no-icon-result">
  <a onclick={(e) => callAction({ item, shiftKey: e.shiftKey })}>
    <i
      class="fas {item.history
        ? 'fa-clock-rotate-left'
        : 'fa-calculator'} entity-icon"
    ></i>
    {#if density === "compact"}
      <div class="one-line-item">
        {#if item.input !== item.result?.toString()}
          {item.input}{#if item.result !== undefined}&nbsp;=&nbsp;{/if}
        {/if}
        {#if item.result !== undefined}
          <span class="result">{item.result ?? ""}</span>
        {/if}
      </div>
    {:else}
      <div class="two-line-item">
        <span>
          {item.input}{#if item.result !== undefined}&nbsp;=&nbsp;{/if}
        </span>
        <span>
          <span class="result">{item.result ?? ""}</span>
        </span>
      </div>
    {/if}
  </a>
</li>

<style>
  .one-line-item {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .two-line-item {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  :global(.density-comfortable) .result,
  :global(.density-spacious) .result {
    font-size: 120%;
  }

  .result {
    font-weight: bold;
    padding: 0 !important;
  }
  li a {
    height: auto !important;
  }
</style>
